import React, { useRef, useState, useEffect, useContext, createContext } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import {
  Table as BaseTable,
  Head as BaseHead,
  Body as BaseBody,
  Row as BaseRow,
  Heading as BaseHeading,
  Cell as BaseCell,
  Label as BaseLabel,
} from './Table.styled';

const StickyShadowContext = createContext(false);
const useStickyShadow = () => useContext(StickyShadowContext);

const StyledCisTable = styled(BaseTable)`
  min-width: 1600px !important;
  min-height: 15rem !important;
`;
const StyledHead = styled(BaseHead)``;
const StyledBody = styled(BaseBody)``;
const StyledRow = styled(BaseRow)``;
const StyledHeading = styled(BaseHeading)`
  ${({ height }) => height && `height: ${height} !important;`}
`;
const StyledCell = styled(BaseCell)`
  vertical-align: middle;
`;
const StyledLabel = styled(BaseLabel)``;
const ScrollWrapper = styled.div`
  overflow-x: auto;
  max-height: 80vh;
  overflow-y: auto;
`;

export const CisTableStickyHeading = styled(StyledHeading)`
  position: sticky;
  top: 0;
  z-index: 3;
  background: ${({ theme }) => theme?.colors?.tertiary || '#fff'};
`;

const StyledStickyActionHeading = styled(CisTableStickyHeading)`
  position: sticky;
  right: 0;
  z-index: 3;
  background: ${({ theme }) => theme?.colors?.tertiary || '#fff'};

  &::before {
    z-index: 3;
    content: '';
    position: absolute;
    left: -20px; // or -15px depending on visual balance
    top: 0;
    width: 20px;
    height: 100%;
    pointer-events: none;
    background: linear-gradient(to left, rgb(200, 200, 200) 0%, rgba(200, 200, 200, 0.1) 100%);
    opacity: ${({ showShadow }) => (showShadow ? 1 : 0)};
    transition: opacity 0.3s ease;
  }
`;
export const CisTableStickyActionHeading = (props) => {
  const showShadow = useStickyShadow();
  return <StyledStickyActionHeading {...props} showShadow={showShadow} />;
};

const StyledStickyActionCell = styled(StyledCell)`
  position: sticky;
  right: 0;
  z-index: 2;
  background: ${({ theme }) => theme?.colors?.background || '#fff'};

  &::before {
    z-index: 2;
    content: '';
    position: absolute;
    left: -20px; // or -15px depending on visual balance
    top: 0;
    width: 20px;
    height: 100%;
    pointer-events: none;
    background: linear-gradient(to left, rgb(200, 200, 200) 0%, rgba(200, 200, 200, 0.1) 100%);
    opacity: ${({ showShadow }) => (showShadow ? 1 : 0)};
    transition: opacity 0.3s ease;
  }
`;
export const CisTableStickyActionCell = (props) => {
  const showShadow = useStickyShadow();
  return <StyledStickyActionCell {...props} showShadow={showShadow} />;
};

export const CisTable = ({ children, ...props }) => {
  const scrollRef = useRef(null);
  const [showShadow, setShowShadow] = useState(false);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handleScroll = () => {
      const { scrollLeft, scrollWidth, clientWidth } = el;
      const isScrolledToEnd = scrollLeft + clientWidth >= scrollWidth - 1;
      setShowShadow(!isScrolledToEnd);
      console.log('Scrolled to the end:', isScrolledToEnd);
    };

    el.addEventListener('scroll', handleScroll);
    handleScroll(); // trigger once on mount

    return () => el.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <ScrollWrapper ref={scrollRef}>
      <StickyShadowContext.Provider value={showShadow}>
        <StyledCisTable {...props}>{children}</StyledCisTable>
      </StickyShadowContext.Provider>
    </ScrollWrapper>
  );
};
CisTable.Head = StyledHead;
CisTable.Body = StyledBody;
CisTable.Row = StyledRow;
CisTable.Heading = StyledHeading;
CisTable.Cell = StyledCell;
CisTable.Label = StyledLabel;
CisTable.StickyHeading = CisTableStickyHeading;
CisTable.StickyActionHeading = CisTableStickyActionHeading;
CisTable.StickyActionCell = CisTableStickyActionCell;

export default CisTable;
